import { Container, Row, Col, Nav } from "react-bootstrap";
import thankYouGAImg from "../assets/img/masterClassImg.jpg";
//import { ArrowRightCircle } from 'react-bootstrap-icons';
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const ThankYouText = () => {
 
  return (
    <section className="career" id="career">
      <Container>
        <Row className="aligh-items-center">
        <Col xs={12} md={6} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={thankYouGAImg} alt="Thank You Img"/>
                </div>}
            </TrackVisibility>
          </Col>
        
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
              {({ isVisible }) =>
              <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                <h1><span className='quoteHeader'>Your Purchase</span> Was Successful.</h1>
                <h5 className="chris">Congratulations! </h5>
                <h4>Welcome to Totlesoft Graphic Academy (TGA).</h4>
                  <p>
                    You just started partnering with one of the world best IT team.
                  </p><br />

                  <h3>TO GAIN ACCESS TO THE ACADEMY...</h3>
                  <h5>Please click below to:</h5>
                  <Nav.Link href="https://chat.whatsapp.com/LDM0EatB7DC6Pot37JiUFR"><h3>JOIN THE CLASS</h3></Nav.Link>
                  <p>Thereafter you will have to introduce yourself in this format:</p>
                  <p>Name</p>
                  <p>Location</p>
                  <p>Device you would use (Smartphone or Laptop or both)</p><br />
                  
                  
                  <Nav.Link href="/academy"><h3>Return to Academy Home Page</h3></Nav.Link><br />
                 
            </div>}
            </TrackVisibility>
          </Col>
          </Row>
      </Container>
    </section>
  )
}
